var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"test"},[_c('img',{class:this.templateIdViewId ? 'pencilSize' : 'pencil',attrs:{"src":require("@/assets/img/logo-whiteloader.svg"),"id":"image"}}),_c('div',{class:this.templateIdViewId ? 'lineSize' : 'line'})])])
}
var staticRenderFns = []

export { render, staticRenderFns }